import React, { useState, useEffect } from 'react'
import { Helmet } from "react-helmet"
import { graphql, StaticQuery } from 'gatsby'
import Layout from '../components/blog/Layout'
import Post from '../components/blog/Post'
import SEO from '../components/seo'

const Blog = function (props) {

    const [key, setKey] = useState(undefined)

    useEffect(() => {
        setKey(localStorage.getItem('theme'))
    }, [])

    return (
        <Layout location={props.location} pageTitle="Semua Blog">
            <Helmet>
                <body className={key} />
            </Helmet>
            <SEO title="Blog" />
            <StaticQuery query={indexQuery} render={data => {
                return (
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3">
                        {data.allMarkdownRemark.edges.map(({ node }) => (
                            <div className="col mb-4" key={node.id}>
                                <Post
                                    title={node.frontmatter.title}
                                    author={node.frontmatter.author}
                                    slug={node.fields.slug}
                                    date={node.frontmatter.date}
                                    body={node.excerpt}
                                    fluid={node.frontmatter.image.childImageSharp.fluid}
                                    tags={node.frontmatter.tags}
                                />
                            </div>
                        ))}
                    </div>
                )
            }} />
        </Layout>
    )
}

const indexQuery = graphql`
    query {
        allMarkdownRemark(sort: {fields: [frontmatter___date], order: DESC}) {
            edges {
                node {
                    id
                    frontmatter {
                        title
                        date(formatString: "MMM Do YYYY")
                        author
                        tags
                        image {
                            childImageSharp {
                                fluid(maxWidth: 600, maxHeight: 300, cropFocus: CENTER, fit: COVER) {
                                    ...GatsbyImageSharpFluid
                                }
                            }
                        }
                    }
                    fields{
                        slug
                    }
                    excerpt
                }
            }
        }
    }
`


export default Blog